import { t as DEFAULT_KEYBOARD_SHORTCUTS } from "./useKeyboardShortcuts-DsXNZYT5.js";
import React from "react";

//#region src/useDocSearchKeyboardEvents.ts
function isEditingContent(event) {
	const element = event.composedPath()[0];
	const tagName = element.tagName;
	return element.isContentEditable || tagName === "INPUT" || tagName === "SELECT" || tagName === "TEXTAREA" || tagName === "BUTTON";
}
function useDocSearchKeyboardEvents({ isOpen, isAskAiActive, onAskAiToggle, onClose, onOpen, keyboardShortcuts = DEFAULT_KEYBOARD_SHORTCUTS }) {
	React.useEffect(() => {
		function onKeyDown(event) {
			var _event$key;
			if (isOpen && event.code === "Escape" && isAskAiActive) {
				onAskAiToggle(false);
				return;
			}
			const isCmdK = keyboardShortcuts["Ctrl/Cmd+K"] && ((_event$key = event.key) === null || _event$key === void 0 ? void 0 : _event$key.toLowerCase()) === "k" && (event.metaKey || event.ctrlKey);
			const isSlash = keyboardShortcuts["/"] && event.key === "/";
			if (event.code === "Escape" && isOpen || isCmdK || !isEditingContent(event) && isSlash && !isOpen) {
				event.preventDefault();
				if (isOpen) onClose();
				else if (!document.body.classList.contains("DocSearch--active")) onOpen();
			}
		}
		window.addEventListener("keydown", onKeyDown);
		return () => {
			window.removeEventListener("keydown", onKeyDown);
		};
	}, [
		isOpen,
		isAskAiActive,
		keyboardShortcuts,
		onOpen,
		onClose,
		onAskAiToggle
	]);
}

//#endregion
export { useDocSearchKeyboardEvents };
//# sourceMappingURL=useDocSearchKeyboardEvents.js.map